<template>
  <div class="layout">
    <div class="layout_con">
      <top-bar title="红色事件"></top-bar>
      <ul class="list">
        <li class="item" v-for="(item, index) in list" :key="index">
          <div class="cir"></div>
          <div class="year">{{ item.period }}</div>
          <div class="title">{{ item.title }}</div>
          <router-link class="to_more" :to="`/memory/incident/details/${item.id}`">详情 ></router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import topBar from '@/components/topBar/index'
export default {
  metaInfo: {
    title: '具相长安-红色记忆'
  },
  components: {
    topBar
  },
  data() {
    return {
      list: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      const { rows: res } = await this.$http.post('/portal/getBigEventList')
      this.list = res
    }
  }
}
</script>

<style lang="less" scoped>
.list {
  padding: 0 0.4rem;
  .item {
    border-left: 0.0267rem solid #a77d4d;
    position: relative;
    padding-bottom: 0.8rem;
    padding-left: 0.4rem;
    &:nth-child(1) {
      padding-top: 0.8rem;
      .to_more {
        top: 0.8rem;
      }
    }
  }
  .cir {
    width: 0.2667rem;
    height: 0.2667rem;
    background: #ba2929;
    border-radius: 50%;
    position: absolute;
    left: -0.16rem;
  }
  .year {
    font-size: 0.3733rem;
    color: #ba2929;
    letter-spacing: 0.0533rem;
    margin-bottom: 0.2667rem;
  }
  .title {
    font-size: 0.48rem;
    color: #222;
    line-height: 1.5;
  }
  .to_more {
    font-size: 0.4267rem;
    color: #ba2929;
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
